import { useEffect, useRef } from 'react';
export default function useTimerRef() {
    const timerRef = useRef(undefined);
    useEffect(() => () => {
        clearTimeout(timerRef.current);
    }, []);
    return timerRef;
}
